import React, { useCallback, useState } from 'react';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Box from '@mui/material/Box';
import RenderStringOrComponent from '../../misc/RenderStringOrComponent';
import useEmotionStyles from '../../hooks/useEmotionStyles';
var styles = function (theme) {
    var _a, _b, _c;
    return ({
        header: {
            cursor: 'pointer',
        },
        titleContainer: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        buttonContainer: {
            display: 'flex',
            justifyContent: 'end',
            width: '40px',
        },
        descriptionContainer: {
            marginRight: '40px',
        },
        button: {
            transform: 'rotate(0)',
            transformOrigin: '50% 50%',
            transition: '.3s',
        },
        buttonRotated: {
            transform: 'rotate(180deg)',
        },
        title: (_a = {
                color: theme.palette.primary.main,
                fontSize: '1.125rem',
                lineHeight: '1.5rem',
                fontWeight: 'bold',
                margin: 0
            },
            _a[theme.breakpoints.down('sm')] = {
                fontSize: '1rem',
            },
            _a),
        defaultDescription: (_b = {
                fontSize: '1rem',
                fontWeight: 500
            },
            _b[theme.breakpoints.down('sm')] = {
                fontSize: '.9rem',
            },
            _b),
        defaultContent: (_c = {
                fontSize: '1rem'
            },
            _c[theme.breakpoints.down('sm')] = {
                fontSize: '.9rem',
            },
            _c),
    });
};
var MessageBox = function (_a) {
    var title = _a.title, description = _a.description, content = _a.content;
    var cs = useEmotionStyles(styles);
    var _b = useState(false), isExpanded = _b[0], setIsExpanded = _b[1];
    var handleTitleClick = useCallback(function () {
        setIsExpanded(!isExpanded);
    }, [isExpanded]);
    var iconClassName = "".concat(cs.button, " ").concat(isExpanded ? cs.buttonRotated : '');
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { mb: 1, className: cs.header, onClick: handleTitleClick },
            React.createElement(Box, { className: cs.titleContainer },
                React.createElement(Box, { mb: 0.5 },
                    React.createElement(RenderStringOrComponent, { toRender: title, className: cs.title })),
                React.createElement("div", { className: cs.buttonContainer },
                    React.createElement(KeyboardArrowDownIcon, { className: iconClassName, color: 'primary' }))),
            description && (React.createElement(Box, { className: cs.descriptionContainer },
                React.createElement(RenderStringOrComponent, { toRender: description, variant: 'body1', className: cs.defaultDescription })))),
        React.createElement(Collapse, { in: isExpanded },
            React.createElement(Box, { mb: 1 },
                React.createElement(RenderStringOrComponent, { toRender: content, variant: 'body1', className: cs.defaultContent })))));
};
export default MessageBox;
